import DocumentsUploadedViewModel from "../components/documentsUploadedViewModel";
import { Router } from "@frui.ts/screens/dist";

export const ExemptionDocumentsUploadedViewModelNavigationName = "exemption_documents";

@Router.registerRoute({
  route: ExemptionDocumentsUploadedViewModelNavigationName,
  name: "exemption_documents",
})
export default class ExemptionDocumentsUploadedViewModel extends DocumentsUploadedViewModel {}
